import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import _Skeleton from "@mui/material/Skeleton";
import React from 'react';
import { useChallenge } from '../../../hooks';
import { GeogroupAvatar } from '../../geogroup-avatar';
import PodiumCard, { podiumOrder, podiumRanksConfig } from './podium-card';
function LeaderboardPodium({
  event,
  items
}) {
  const {
    getProgressValueWithUnit
  } = useChallenge();
  if (event?.challengeTemplate && event.challengeTemplate.type === 'noTarget') return /*#__PURE__*/React.createElement(React.Fragment, null);
  const withoutPointsUnit = event?.challengeTemplate?.progressWeightingMode === 'EMPLOYEE_RATIO';
  const loading = items === undefined;
  return /*#__PURE__*/React.createElement(_Box, {
    alignItems: "flex-end",
    display: {
      xs: 'none',
      md: 'flex'
    },
    flex: "1 1 auto",
    flexDirection: "row",
    gap: 3
  }, podiumOrder.map(({
    itemIndex,
    rank
  }) => {
    const item = items?.[itemIndex];
    return /*#__PURE__*/React.createElement(PodiumCard, {
      avatar: loading || item ? /*#__PURE__*/React.createElement(GeogroupAvatar, {
        geogroup: item?.parentTitle ? {
          title: item.parentTitle,
          photo: item.parentPhoto
        } : item,
        size: podiumRanksConfig[rank].avatarSize
      }) : null,
      key: rank,
      rank: rank
    }, /*#__PURE__*/React.createElement(_Typography, {
      noWrap: true,
      fontSize: "0.9375rem",
      fontWeight: 600,
      title: item ? item.parentTitle ? `${item.parentTitle} - ${item.title}` : item.title : ''
    }, item ? item.parentTitle ? `${item.parentTitle} - ${item.title}` : item.title : loading ? /*#__PURE__*/React.createElement(_Skeleton, {
      variant: "text",
      width: "100%"
    }) : '–'), /*#__PURE__*/React.createElement(_Typography, {
      fontSize: "1.125rem",
      fontWeight: 800
    }, event?.challengeTemplate && item ? getProgressValueWithUnit(event.challengeTemplate.type, item.progressValue, {
      withoutPointsUnit
    }) : loading ? /*#__PURE__*/React.createElement(_Skeleton, {
      variant: "text",
      width: 100
    }) : '–'));
  }));
}
export default LeaderboardPodium;